// @flow

export const TREE = 'usersModule'
export const TABLE_BRANCH = 'table'
export const OPERATIONS_BRANCH = 'operations'
export const BILLING_OP_TREE = 'accountsModule'
export const BILLING_OPERATIONS_BRANCH = 'billingInfoOperation'

// Operations
export const ADD_USER = '@usersModule/ADD_USER'
export const EDIT_USERS = '@usersModule/EDIT_USER'
export const DELETE_USER = '@usersModule/DELETE_USER'
export const EDIT_BILLING_INFO = '@usersModule/EDIT_BILLING_INFO'
